import React, { useRef, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import './Card.scss'
import PhoneIcon from '../../../assets/PhoneIcon'
import EmailIcon from '../../../assets/EmailIcon'
import RatingIcon from '../../../assets/RatingIcon'

import NameIcon from '../../../assets/NameIcon'
import DotsIcon from '../../../assets/DotsIcon'
import LocationIcon from '../../../assets/LocationIcon'
import useCheckMobileScreen from '../../../common/hooks/use-check-mobile-screen-hook'
import CloseIcon from '../../../assets/CloseIcon'
import PopupCard from '../PopupCard/PopupCard'
import { convertToTitleCase, downloadBase64Csv } from '../../../common/utils/appUtils'
import ActiveIcon from '../../../assets/ActiveIcon'
import InActiveIcon from '../../../assets/InActiveIcon'
import DownloadIcon from './../../../assets/DownloadIcon';
import { bulkAddProductReceivingHelper } from '../../../helper/settings-helper'
import DownloadIconBulktemplate from '../../../assets/UploadIcon';
import UploadIcon from './../../../assets/UploadIcon';

const Card = (props) => {
  const isMobile = useCheckMobileScreen()
  const [isCardActive, setIsCardActive] = useState(false)
  const [showBulkUploadPopup, setShowBulkUploadPopup] = useState(false)
  const [bulkUploadFile, setBulkUploadFile] = useState(null)
  const [isUploadingBulkFile, setIsUploadingBulkFile] = useState(false)
  const [bulkErrorReport, setBulkErrorReport] = useState(null)
  const bulkFileInputRef = useRef(null)

  const resetBulkUpload = () => {
    setShowBulkUploadPopup(false)
    setBulkUploadFile(null)
    setBulkErrorReport(null)
  }

  const handleBulkUpload = (event) => {
    event.stopPropagation()
    setBulkErrorReport(null)
    setShowBulkUploadPopup(true)
  }

  const handleFileChange = (event) => {
    setBulkUploadFile(event.target.files?.[0] || null)
    // Clear any prior error report once the user picks a corrected file.
    setBulkErrorReport(null)
  }

  const openBulkFilePicker = (event) => {
    event.stopPropagation()
    bulkFileInputRef.current?.click()
  }

  const downloadErrorReport = () => {
    if (!bulkErrorReport?.csvBase64) return
    downloadBase64Csv(bulkErrorReport.csvBase64, bulkErrorReport.filename)
  }

  const uploadBulkFile = async () => {
    if (!bulkUploadFile || !props.branchId) return

    setIsUploadingBulkFile(true)
    setBulkErrorReport(null)
    try {
      await bulkAddProductReceivingHelper(props.branchId, bulkUploadFile)
      if (props.onShowAlert) {
        props.onShowAlert('success', 'Bulk product receiving uploaded successfully.')
      }
      props.onBulkUploadComplete?.()
      resetBulkUpload()
    } catch (err) {
      console.log('Bulk upload failed:', err)
      const errObj = typeof err === 'string' ? { message: err } : err || {}

      // Row-level validation failure: keep the popup open and surface the
      // annotated error CSV so the user can fix the flagged rows and retry.
      if (errObj.error_csv_base64) {
        setBulkErrorReport({
          message: errObj.message || 'Some rows failed validation.',
          rowCount: Array.isArray(errObj.row_errors)
            ? errObj.row_errors.length
            : null,
          csvBase64: errObj.error_csv_base64,
          filename: errObj.error_csv_filename || 'bulk_receiving_errors.csv',
        })
      } else if (props.onShowAlert) {
        props.onShowAlert(
          'error',
          errObj.message || 'Bulk upload failed. Please try again.'
        )
      }
    } finally {
      setIsUploadingBulkFile(false)
    }
  }

  return (
    <div
      className={`card product ${props?.cardCrown && 'spaceTop'}`}
      onClick={props.handleClick}
    >
      {props.cardCrown && (
        <div className={`cardCrown ${props.primary && 'primary'}`}>
          {props.cardCrown}
        </div>
      )}
      <div
        className={`cardHeader dFlex flexNowrap aiCenter ${
          !props.noHeaderBorder && 'border'
        }`}
      >
        {props.queryHeader && (
          <div className="queryHeader dFlex jcSpaceBetween">
            <div className="queryHeaderItem dFlex flexColumn">
              <div className="queryHeading">Query No.</div>
              {props.queryHeader.queryNo}
            </div>
            <div className="queryHeaderItem dFlex flexColumn">
              <div className="queryHeading">Date</div>
              {props.queryHeader.date}
            </div>
            <div
              className={`queryHeaderItem dFlex flexColumn status ${props.queryHeader.status}`}
            >
              {props.queryHeader.status}
            </div>
          </div>
        )}
        {props.userInitials && (
          <div className="cardIcon dFlex jcContentCenter aiCenter">
            <div className="userInitials">{props.userInitials}</div>
          </div>
        )}
        <div className="cardHeaderDetails">
          <div className="headerSup">{props.headerSup}</div>
          <div className="headerMain">{props.headerMain}</div>
          {props.headerProduct && (
            <div className={`productName`}>
              {props.headerProduct.productType && (
                <span className={`item name ${props.strong ?? 'strong'}`}>
                  {props.headerProduct.productType}
                </span>
              )}
              {props.headerProduct.productCategory && (
                <span className={`item type ${props.strong ?? 'strong'}`}>
                  {props.headerProduct.productCategory}
                </span>
              )}
              {props.headerProduct.quantity && (
                <span className={`item space ${props.strong ?? 'strong'}`}>
                  {props.headerProduct.quantity}
                </span>
              )}
            </div>
          )}
          {props.exchangeItem && (
            <div className="exchangeItem">{props.exchangeItem}</div>
          )}
        </div>
        {props.cardRight && (
          <div
            className={`cardHeaderRight alignSelf ${
              props.nowrap ? 'nowrap' : ''
            } ${
              props.cardRight.startsWith('BDT') &&
              props.cardRight.split('BDT ')[1] !== '0'
                ? props.cardRight.split('BDT ')[1] > 0
                  ? 'textGreen'
                  : 'textRed'
                : ''
            } `}
          >
            {props.cardRight}
          </div>
        )}
        {(props.cardAction || props.showBulkUpload) && (
          <div className="cardHeaderRight">
            <div className="cardActionIcon">
              {props.showBulkUpload && (
                <span onClick={handleBulkUpload}>
                  <UploadIcon />
                </span>
              )}
              {props?.hasOwnProperty('isActive') && (
                <span>
                  {props.isActive ? <ActiveIcon /> : <InActiveIcon />}
                </span>
              )}

              {props.cardAction &&
                (isCardActive ? (
                  <span onClick={() => setIsCardActive(false)}>
                    <CloseIcon />
                  </span>
                ) : (
                  <span onClick={() => setIsCardActive(true)}>
                    <DotsIcon />
                  </span>
                ))}
            </div>
            {props.cardAction && (
              <ul
                className={`cardActionsWrapper ${isCardActive ? 'show' : 'hide'}`}
              >
                {props?.cardAction?.map((action) => {
                  return (
                    <li
                      className="actionItem"
                      onClick={() => {
                        setIsCardActive(false)
                        props?.onCardAction(action)
                      }}
                    >
                      {convertToTitleCase(action)}
                    </li>
                  )
                })}
              </ul>
            )}
          </div>
        )}
        {showBulkUploadPopup && (
          <PopupCard
            header="Bulk Upload Product Receiving"
            body={
              <div className="bulkUploadPopupBody">
                <p>Select a CSV or Excel file to upload for this branch.</p>
                <button
                  type="button"
                  className="btn btnPrimaryOutlined"
                  onClick={openBulkFilePicker}
                >
                  Choose file
                </button>
                <div style={{ marginTop: '12px', minHeight: '20px' }}>
                  {bulkUploadFile ? bulkUploadFile.name : 'No file selected'}
                </div>
                <input
                  ref={bulkFileInputRef}
                  type="file"
                  style={{ display: 'none' }}
                  accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                  onChange={handleFileChange}
                />
                {bulkErrorReport && (
                  <div className="bulkUploadErrorBox">
                    <div className="bulkUploadErrorTitle">
                      {bulkErrorReport.rowCount
                        ? `${bulkErrorReport.rowCount} row(s) failed validation`
                        : bulkErrorReport.message}
                    </div>
                    <p className="bulkUploadErrorHint">
                      Download the error report, fix the flagged rows (see the
                      "errors" column), then re-upload the corrected file.
                    </p>
                    <button
                      type="button"
                      className="btn btnPrimaryOutlined"
                      onClick={downloadErrorReport}
                    >
                      Download error report
                    </button>
                  </div>
                )}
              </div>
            }
          >
            <button
              className="btn btnPrimaryOutlined"
              onClick={resetBulkUpload}
              disabled={isUploadingBulkFile}
            >
              Cancel
            </button>
            <button
              className="btn btnPrimary ml-5"
              onClick={uploadBulkFile}
              disabled={!bulkUploadFile || !props.branchId || isUploadingBulkFile}
            >
              {isUploadingBulkFile ? 'Uploading...' : 'Upload'}
            </button>
          </PopupCard>
        )}
      </div>
      <div
        className={`cardBody ${props.cardFooter && 'border'} ${
          props.shippingAddress && 'borderBig'
        }`}
      >
        {props.product && (
          <div className={`productName`}>
            <span className={`item name ${props.strong ?? 'strong'}`}>
              {props.product && props.product.productName}
            </span>
            <span className={`item type ${props.strong ?? 'strong'}`}>
              {props.product && props.product.dose}
            </span>
            <span className={`item space ${props.strong ?? 'strong'}`}>
              {props.product && props.product.quantity}
            </span>
          </div>
        )}
        {props.productDesc && (
          <div className={`productDesc ${props.cardFooter && 'strong'}`}>
            {props.productDesc || 'Lorem ipsum dolor sit amet consectetur.'}
          </div>
        )}
        <ul className="userContactDetails">
          {props?.hasOwnProperty('name') && (
            <li className="userContact">
              <NameIcon />
              {props.name}
            </li>
          )}
          {props?.hasOwnProperty('phone') && (
            <li className="userContact dFlex">
              <PhoneIcon />
              {props.phone}
            </li>
          )}
          {props?.hasOwnProperty('rating') && (
            <li className="userContact">
              <RatingIcon />
              {props.rating}
            </li>
          )}
          {props?.hasOwnProperty('email') && (
            <li className="userContact">
              <EmailIcon />
              {props.email}
            </li>
          )}

          {(props?.hasOwnProperty('location') ||
            props?.hasOwnProperty('locations')) && (
            <li className="userContact">
              <LocationIcon />
              {props.locations && Array.isArray(props.locations)
                ? [
                    ...new Set(
                      props.locations
                        .map((loc) => loc.zone)
                        .filter((zone) => zone)
                    ),
                  ].join(', ')
                : props.location}
            </li>
          )}
          {props.onboardAt && (
            <li className="userContact">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
              Onboarded: {props.onboardAt}
            </li>
          )}
        </ul>
        {props.documents && (
          <div className="documentsName">
            <span className="item name">Due Date: 04 Dec 2023</span>
            <span className="item type">Paymeny Mode: DiGi Pay</span>
          </div>
        )}
        {props.orderBook && (
          <div className="documentsName">
            <span className="item name">
              Order Qty: {props.orderBook.totalQuantity}
            </span>
            {props.orderBook.receivableQuantity && (
              <span className="item type">
                Received Qty: {props.orderBook.receivableQuantity}
              </span>
            )}
          </div>
        )}
        {props.sales && <div className="productDesc">{props.sales}</div>}
        {props.orderStatus && (
          <div className={`${props?.orderStatus?.color} orderStatus`}>
            {props?.orderStatus?.text}
          </div>
        )}
        {props.actionButtons && (
          <div className="actionButtons mt-5">
            <button className="btn btnPrimaryOutlined">CANCEL</button>
            <button className="btn btnPrimary ml-5">CONFIRM</button>
          </div>
        )}
        {props.billingAddress && (
          <div className="addressDetails">
            <div className="addressType">Billing Address</div>
            <div className="address dFlex flexNowrap">
              <LocationIcon />
              {props.billingAddress}
            </div>
          </div>
        )}
      </div>
      <div className="cardFooter">
        {props.cardFooter && (
          <div className="itemBack dFlex jc-space-even">
            {props.cardFooter.expiryDate && (
              <div className="item date dFlex flexColumn">
                <small>Expiry Date</small>
                {props.cardFooter.expiryDate}
              </div>
            )}
            {!isMobile && (
              <div className="item loss dFlex flexColumn ">
                <small>Return Loss</small>BDT{' '}
                {props.cardFooter.returnLossAmount}
              </div>
            )}
            {!isMobile && (
              <div className="item loss dFlex flexColumn no-border">
                <small>Receivable Amt</small>BDT{' '}
                {props.cardFooter.recievableAmounut}
              </div>
            )}
            {isMobile && (
              <div className="dFlex jcSpaceBetween aiCenter ">
                <div className="item loss dFlex flexColumn mt-2">
                  <small>Return Loss</small>BDT{' '}
                  {props.cardFooter.returnLossAmount}
                </div>
                <div className="item loss dFlex flexColumn">
                  <small>Receivable Amt</small>BDT{' '}
                  {props.cardFooter.recievableAmounut}
                </div>
              </div>
            )}
          </div>
        )}
        {props.queryFooter && (
          <div className="queryFooter dFlex jcSpaceBetween">
            <div className="queryFooterItem dFlex flexColumn">
              <div className="queryHeading">User Type</div>
              {props.queryFooter.userType}
            </div>
            <div className="queryFooterItem dFlex flexColumn">
              <div className="queryHeading">Name</div>
              {props.queryFooter.name}
            </div>
            <div className="queryFooterItem dFlex flexColumn">
              <div className="queryHeading">Phone Number</div>
              {props.queryFooter.mobileNo}
            </div>
          </div>
        )}
        {props.queryDesc && (
          <div className="querySubject mt-2">
            <div className="queryHeading">Subject</div>
            <div className="queryDesc">{props.queryDesc}</div>
          </div>
        )}
        {props.shippingAddress && (
          <div className="addressDetails">
            <div className="addressType">Shipping Address</div>
            <div className="address dFlex flexNowrap">
              <LocationIcon />
              {props.shippingAddress}
            </div>
          </div>
        )}
        {props.address && (
          <div className="addressDetails">
            <div className="addressType"> Address</div>
            <div className="address dFlex flexNowrap">
              <LocationIcon />
              {props.address}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

Card.propTypes = {
  strong: PropTypes.bool,
  cardCrown: PropTypes.bool,
  online: PropTypes.bool,
  product: PropTypes.bool,
  productDesc: PropTypes.bool,
  phone: PropTypes.bool,
  email: PropTypes.bool,
  location: PropTypes.bool,
  userInitials: PropTypes.bool,
  documents: PropTypes.bool,
  headerSup: PropTypes.string,
  headerMain: PropTypes.string,
  cardRight: PropTypes.string,
  actionButtons: PropTypes.bool,
  showBulkUpload: PropTypes.bool,
  branchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onBulkUploadComplete: PropTypes.func,
  onShowAlert: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(Card)
